import * as yup from 'yup'
import i18n from '../../i18n'
import { isEmpty } from 'lodash'
import * as IbanKit from 'ibankit'
import { AccountIdTypeEnum } from '../../types'
import config from '../../config'

export const IbanBeneficiarySchema = yup.object().shape({
  iban: yup
    .string()
    .test('ibanIsRequired', i18n.t('thisFieldIsRequired', 'This field is required'), function () {
      return (
        this.parent.accountIdType === AccountIdTypeEnum.accountNumber || !isEmpty(this.parent.iban)
      )
    })
    .test('incorrectIbanFormat', i18n.t('incorrectIbanFormat'), function () {
      return (
        this.parent.accountIdType === AccountIdTypeEnum.accountNumber ||
        IbanKit.IBAN.isValid(this.parent.iban?.trim() || '')
      )
    })
    .test(
      'ibanIsNotSupportedForThisCountry',
      i18n.t('ibanIsNotSupportedForThisCountry', 'IBAN is not supported for this country'),
      function () {
        if (this.parent.accountIdType === AccountIdTypeEnum.accountNumber) return true
        const iban = this.parent.iban?.trim()
        if (!iban || !IbanKit.IBAN.isValid(iban)) return true
        const normalizedIBAN = IbanKit.IBAN.electronicFormat(iban)
        const formattedIban = new IbanKit.IBAN(normalizedIBAN)
        const countryCode = formattedIban.getCountryCode()
        return config.ibanSupportedCountries.includes(countryCode)
      },
    ),
})
